<template>
  <!-- eslint-disable -->
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="3" class="mb-md-0 mb-2">
            <label>Fecha de Solicitud</label>
            <b-form-input
              type="date"
              v-model="fechaSolicitud"
              @input="filter"
            />
          </b-col>
          <b-col md="3" class="mb-md-0 mb-2">
            <label>Número de documento</label>
            <b-form-input 
                v-model="documentCode" 
                placeholder="Número de documento" 
                @input="filter"/>
          </b-col>
          <b-col md="6" class="mt-2 justify-content-end d-flex">
            <b-button
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <span class="align-middle">Borrar</span>
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click.prevent="agregar"
            >
              <span class="align-middle">Agregar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      fechaSolicitud: '',
      documentCode: '',
      arrayFilters: [],
    };
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  methods: {
    filter() {
      this.arrayFilters = [];
      
      this.arrayFilters.push({
          keyContains: 'quote.state',
          key: 'contains',
          value: 'Venta'
      });

      if (this.fechaSolicitud) {
        const startOfDay = new Date(this.fechaSolicitud);
        startOfDay.setHours(0, 0, 0, 0);
        startOfDay.setDate(startOfDay.getDate() + 1);

        const endOfDay = new Date(this.fechaSolicitud);
        endOfDay.setHours(0, 0, 0, 0);
        endOfDay.setDate(endOfDay.getDate() + 2);

        this.arrayFilters.push({
          keyContains: 'quote.updated_at',
          key: 'gte',
          value: startOfDay, 
        });

        this.arrayFilters.push({
          keyContains: 'quote.updated_at',
          key: 'lt', 
          value: endOfDay, 
        });
      }

      if (this.documentCode) {
        this.arrayFilters.push({
          keyContains: 'documentCode',
          key: 'documentCode',
          value: this.documentCode
        });
      }

      this.$parent.$parent.arrayFilters = this.arrayFilters;
      this.$parent.$parent.getData();
    },
    agregar(){
      this.$router.push({ name: 'caja-add' })
    },

    clean() {
      this.fechaSolicitud = '';
      this.documentCode = '';
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters;
      this.$parent.$parent.getData();
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>